import React, { createContext, useCallback, useContext, useState } from 'react';
import { HttpPostData } from "../common/Util";
import { Navigate, useLocation } from "react-router-dom";
import { NewProductParam, PaymentPageType } from "../common/Types";

/**
 * ���O�C���y�[�W�ɓn�����y�[�W�̃p�����[�^����A���[�U�o�^�̃y�[�W�̃^�C�v��Ԃ��B
 * @param prop
 */
export function PageTypeParamConverter(prop: NewProductParam): RegisterPageType {
    if (prop == null) {
        return RegisterPageTypeEnum.License;
    }
    switch (prop.paymentPageType) {
        case PaymentPageType.New:
            return RegisterPageTypeEnum.License;
        case PaymentPageType.Continue:
            return RegisterPageTypeEnum.License;
        case PaymentPageType.Pccase:
            return RegisterPageTypeEnum.Pccase;
        default:
            return RegisterPageTypeEnum.License;
    }
}

/**
 * �o�^�y�[�W�̃^�C�v
 * */
export const RegisterPageTypeEnum = {
    License: 1,
    Pccase: 2,
    TrialLicense: 3,
} as const

 export type RegisterPageType = typeof RegisterPageTypeEnum[keyof typeof RegisterPageTypeEnum];

export type RegisterPageInfo = {
    registerPageType: RegisterPageType,
}

export type RegisterPageInfoState = {
    registerPageInfo: RegisterPageInfo;
    setRegisterPageInfo: (current: RegisterPageInfo) => void;
}

const DefaultParam: RegisterPageInfoState = {
    registerPageInfo: { registerPageType: RegisterPageTypeEnum.License },
    setRegisterPageInfo: () => { },
}

export const RegisterPageContext = createContext<RegisterPageInfoState>(DefaultParam);

const UseRegisterPageContext = () => {
    return useContext<RegisterPageInfoState>(RegisterPageContext);
}

export const RegisterPageContextState = (): RegisterPageInfoState => {
    const [registerPageInfo, setRegisterPageInfo] = useState<RegisterPageInfo>({ registerPageType: RegisterPageTypeEnum.License });

    const setRegisterPageInfoValue = useCallback(
        (current: RegisterPageInfo): void => {
            setRegisterPageInfo(current);
        },[]
    );

    return {
        registerPageInfo,
        setRegisterPageInfo,
    }
}